import { Injectable } from '@angular/core';
import { InAppBrowser, InAppBrowserOptions } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { ActionSheetController, ModalController } from '@ionic/angular';

import { TutorialComponent } from '../component/tutorial/tutorial.component';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class HelpService {
  iabOptions: InAppBrowserOptions = {
    location: 'no',
    hidenavigationbuttons: 'yes',
    toolbarposition: 'bottom',
    toolbarcolor: '#0e53a1',
    navigationbuttoncolor: '#ffffff',
    hideurlbar: 'yes',
    closebuttoncaption: 'Cerrar',
  };

  constructor(
    private actionSheetCtrl: ActionSheetController,
    private iab: InAppBrowser,
    private auth: AuthService,
    private modalCtrl: ModalController
  ) {}

  async presentActionSheet(): Promise<any> {
    const isAuthenticated = await this.auth.isAuthenticated();
    const actionSheet: HTMLIonActionSheetElement = await this.actionSheetCtrl.create({
      header: 'Ayuda',
      buttons: [
        {
          text: 'Campus CCM',
          handler: () => {
            this.presentActions({
              header: 'Campus CCM',
              email: 'transportec@tvr.com.mx',
              whatsapp: 'https://wa.me/message/FZRICHJAXEXDB1',
            });
          },
        },
        {
          text: 'Campus CEM',
          handler: () => {
            this.presentActions({
              header: 'Campus CEM',
              email: 'atencion.cem@scholastico.mx',
              whatsapp: 'https://wa.me/+525573735359',
            });
          },
        },
        {
          text: 'Campus CEM 2',
          handler: () => {
            this.presentActions({
              header: 'Campus CEM 2',
              email: 'atencion.cem@scholastico.mx',
              whatsapp: 'https://wa.me/+525516096692',
            });
          },
        },
        {
          text: 'Campus Guadalajara',
          handler: () => {
            this.presentActions({
              header: 'Campus Guadalajara',
              email: 'transporte.gdl@scholastico.mx',
              whatsapp: 'http://wa.me/+525538436461',
            });
          },
        },
        {
          text: 'Campus Querétaro',
          handler: () => {
            this.presentActions({
              header: 'Campus Querétaro',
              email: 'atencion.tec@scholastico.mx',
              whatsapp: 'https://wa.me/525538436461',
            });
          },
        },
        {
          text: 'Prepa Esmeralda',
          handler: () => {
            this.presentActions({
              header: 'Prepa Esmeralda',
              email: 'atencion.tec@scholastico.mx',
              whatsapp: 'https://wa.me/525538436461',
            });
          },
        },
        {
          text: 'Tec Services',
          handler: () => {
            this.presentActions({ header: 'Tec Services', email: 'tecservices@servicios.tec.mx' });
          },
        },
        {
          text: 'Soporte técnico App',
          handler: () => {
            this.presentActions({ header: 'Soporte técnico App', email: 'contacto@tecservice.app' });
          },
        },
        {
          text: 'Compra por QR',
          handler: () => {
            actionSheet.dismiss({
              action: 'scanQR',
            });
          },
          cssClass: !isAuthenticated ? 'hidden' : '',
        },
        {
          text: 'Cancelar',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          },
        },
      ],
    });
    await actionSheet.present();
    const { data } = await actionSheet.onDidDismiss();
    return data;
  }

  async presentActions(campusOptions: { header: string; email: string; whatsapp?: string }) {
    const whatsappA = [];
    if (campusOptions.whatsapp) {
      whatsappA.push({
        text: 'Whatsapp',
        handler: () => {
          this.iab.create(campusOptions.whatsapp, '_system');
        },
      });
    }
    const actionSheet: HTMLIonActionSheetElement = await this.actionSheetCtrl.create({
      header: campusOptions.header,
      buttons: [
        ...whatsappA,
        {
          text: 'E-mail',
          handler: () => {
            this.iab.create('mailto:' + campusOptions.email + '?subject=Soporte Movilidad Tec', '_system');
          },
        },
        {
          text: 'Cancelar',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          },
        },
      ],
    });
    actionSheet.present();
  }

  async deleteAccount() {
    const actionSheet: HTMLIonActionSheetElement = await this.actionSheetCtrl.create({
      header: 'Otros',
      buttons: [
        {
          text: 'Eliminar cuenta',
          handler: () => {
            this.iab.create('mailto:contacto@tecservice.app?subject=Deseo eliminar mi cuenta', '_system');
          },
        },
        {
          text: 'Cancelar',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          },
        },
      ],
    });
    actionSheet.present();
  }

  async presentTicketsTutorialMenu() {
    const actionSheet = await this.actionSheetCtrl.create({
      header: 'Selecciona tutorial',
      buttons: [
        {
          text: 'Suscripción',
          handler: () => {
            this.modalCtrl
              .create({
                component: TutorialComponent,
                componentProps: { tutorial: 'transportec-suscripcion' },
              })
              .then((modal) => {
                modal.present();
              });
          },
        },
        {
          text: 'Rutas y horarios',
          handler: () => {
            this.modalCtrl
              .create({
                component: TutorialComponent,
                componentProps: { tutorial: 'transportec-rutas' },
              })
              .then((modal) => {
                modal.present();
              });
          },
        },
        {
          text: 'Compra de boletos',
          handler: () => {
            this.modalCtrl
              .create({
                component: TutorialComponent,
                componentProps: { tutorial: 'transportec-boletos' },
              })
              .then((modal) => {
                modal.present();
              });
          },
        },
        {
          text: 'Recarga de saldo',
          handler: () => {
            this.modalCtrl
              .create({
                component: TutorialComponent,
                componentProps: { tutorial: 'transportec-saldo' },
              })
              .then((modal) => {
                modal.present();
              });
          },
        },
        {
          text: 'Calificar servicio',
          handler: () => {
            this.modalCtrl
              .create({
                component: TutorialComponent,
                componentProps: { tutorial: 'transportec-calificar' },
              })
              .then((modal) => {
                modal.present();
              });
          },
        },
        {
          text: 'Centro de ayuda',
          handler: () => {
            this.modalCtrl
              .create({
                component: TutorialComponent,
                componentProps: { tutorial: 'transportec-ayuda' },
              })
              .then((modal) => {
                modal.present();
              });
          },
        },
      ],
    });
    actionSheet.present();
  }
}
